import styled from '@emotion/styled'
import * as React from 'react'

import { StateCircle } from '../circle/StateCircle'
import Icon from '../Icon'
import { Space } from '../space'
import { backgroundColorMap, borderColorMap, highlightColorMap } from '../types/mapper'
import { MessageType } from '../types/types'
import { Typography } from '../typography'

export type MessageBoxProps = {
  actionRenderer?: React.ReactNode
  children: React.ReactNode
  showStateCircle?: boolean
  size?: 'small' | 'default'
  state?: MessageType
  title?: string
}

type MessageBoxStyleProps = {
  background?: string
  border: string
  size?: 'small' | 'default'
}

const StyledBox = styled(Space)<MessageBoxStyleProps>`
  color: var(--Graphite);
  background: ${props => props.background};
  border: ${props => `solid 1px ${props.border}`};
  border-radius: 4px;
  * button {
    color: var(--Graphite);
    &:hover {
      color: var(--Graphite);
    }
  }
`

export function MessageBox({
  actionRenderer,
  children,
  showStateCircle,
  size,
  state,
  title
}: MessageBoxProps) {
  const highlightColor = highlightColorMap.get(state)
  const backgroundColor = backgroundColorMap.get(state)
  const borderColor = borderColorMap.get(state)

  let padding = 6
  if (size === 'small') {
    padding = 3
  }

  return (
    <StyledBox
      background={backgroundColor}
      border={borderColor}
      color={highlightColor}
      p={padding}
      size={size}
    >
      <Space isflex flexDirection="row">
        {title && (
          <Space pr={4} pt={1}>
            <Icon color={highlightColor} name="circleInfo" size="large" />
          </Space>
        )}
        <Space isflex flexDirection="column" flexGrow={1}>
          {title && (
            <Space mb={2}>
              <Typography variant="sh3">{title}</Typography>
            </Space>
          )}
          <Space isflex flexDirection="row">
            <Space isflex alignItems="center" flexGrow={1}>
              {state && showStateCircle && <StateCircle state={state} />}
              <div className="message-box-children-wrapper">{children}</div>
            </Space>
            <Space justifyContent="flex-end">{actionRenderer}</Space>
          </Space>
        </Space>
      </Space>
    </StyledBox>
  )
}
